'use client'

import { useState, useEffect } from 'react'

import Link from 'next/link'
import Modal from '@/components/modal/Modal'
import { Button, OverlayArrow, Tooltip, TooltipTrigger } from 'react-aria-components'

const ShareBtn = ({ btnClass }) => (
  <TooltipTrigger delay={0}>
    <Button className={btnClass}>
      <svg className="pointer-events-none h-24 w-24" aria-hidden="true">
        <use href={`${process.env.NEXT_PUBLIC_SPRITE_PATH}#icon-share`}></use>
      </svg>
    </Button>
    <Tooltip>
      <OverlayArrow>
        <svg width={8} height={8} viewBox="0 0 8 8">
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      Share
    </Tooltip>
  </TooltipTrigger>
)

export default function ShareModal({
  btnClass = 'inline-flex h-40 w-40 items-center justify-center rounded-sm text-fg-title hover:bg-theme-accent transition-colors duration-200 ease-in-out',
}: {
  btnClass?: string
}) {
  const [currentUrl, setCurrentUrl] = useState(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href)
    }
  }, [])

  if (!currentUrl) {
    return null
  }

  const encodedUrl = encodeURIComponent(currentUrl)

  const shareBtnClass =
    'inline-flex h-46 w-46 items-center justify-center rounded-sm text-fg-title border hover:bg-primary-50 hover:border-primary-50 transition-colors duration-200 ease-in-out'

  return (
    <Modal title="Share with" trigger={<ShareBtn btnClass={btnClass} />} size="small">
      <div className="flex flex-col gap-s p-m m:px-s">
        <div className="flex w-full flex-col gap-s">
          <div className="flex gap-xs">
            <Link
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`}
              target="_blank"
              className={shareBtnClass}>
              <svg className="h-20 w-20" aria-hidden="true">
                <use href="/img/sprite.svg#icon-linkedin"></use>
              </svg>
            </Link>

            <Link
              href={`https://x.com/intent/tweet?text=${encodedUrl}`}
              target="_blank"
              className={shareBtnClass}>
              <svg className="h-20 w-20" aria-hidden="true">
                <use href="/img/sprite.svg#icon-x"></use>
              </svg>
            </Link>

            <Link
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
              target="_blank"
              className={shareBtnClass}>
              <svg className="h-22 w-22" aria-hidden="true">
                <use href="/img/sprite.svg#icon-facebook"></use>
              </svg>
            </Link>
          </div>
        </div>

        <div className="flex w-full flex-col gap-xs">
          <span className="mb-0 font-bold">Or copy link:</span>

          <div className="flex">
            <input
              className="input--small w-full rounded-r-none border border-r-0 shadow-none"
              type="text"
              value={currentUrl}
              readOnly
            />
            <button
              className="btn btn--solid btn--small rounded-l-none text-14"
              onClick={() => navigator.clipboard.writeText(currentUrl)}>
              Copy
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
